import { render } from "./SvgInline.vue?vue&type=template&id=fc2764c6"
import script from "./SvgInline.vue?vue&type=script&lang=js"
export * from "./SvgInline.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__